const us = {
  subMenu: {
    managementScreenUserRegistration: 'Admin User Registration',
    accountManagement: 'Account Management',
    userManagement: 'User Management',
    order: 'Order',
    itemInformation: 'Item Info',
    itemImageUpload: 'Upload Item Image',
    searchConfig: 'Search Option',
    category: 'Category',
    menu: 'Menu',
    price: 'Price',
    ad: 'Ad',
    recommendOnOrder: 'Recommended',
    timedRecommend: 'Limited Time Recommended',
    eventInformation: 'Event Info',
    eventList: 'Event List',
    operationalManagement: 'Operational Management',
    allShopsConfig: 'Universal Setting',
    shopList: 'Restaurant List',
    groupConfig: 'Set up group',
    'sumahoDeBikkurapon-jp': 'Side Dish Bikkurapon',
    sumahoDeBikkurapon: 'Side Dish Bikkurapon',
    sumahoDeBikkuraponConfig: 'Side Dish Bikkurapon Setting',
  },
  common: {
    language: 'Language',
    create: 'Create',
    csvUpload: 'CSV upload',
    csvDownload: 'CSV download',
    displayCount: 'Display Count',
    search: 'Search',
    itemCode: 'Item Code',
    itemName: 'Item Name',
    itemNameJapanese: 'Item Name(Japanese)',
    itemNameEnglish: 'Item Name(English)',
    itemNameTraditionalChinese: 'Item Name(TraditionalChinese)',
    itemNameSimplifiedChinese: 'Item Name(SimplifiedChinese)',
    itemNameKorean: 'Item Name(Korean)',
    calorie: 'Carolie',
    calorieUnit: 'Cal',
    manufacturingCategory: 'Category',
    topping: 'Garnish',
    image: 'Image',
    normalImage: 'Regular Image',
    wideImage: 'Wide Image',
    normal: 'Regular',
    wide: 'Wide',
    edit: 'Edit',
    totalCount: 'Total Count',
    itemUnit: 'item',
    back: 'Back',
    inputComplete: 'Done',
    csvFile: 'CSV files',
    import: 'Reference',
    upload: 'Upload',
    imageUpload: 'Upload Image',
    csvFileUploadDescription: 'Upload CSV files up to 5MB.',
    fileName: 'File name',
    status: 'Status',
    uploadDate: 'Upload Date',
    importStartTime: 'Import Start Time',
    importEndTime: 'Import End Time',
    delete: 'Delete',
    categoryName: 'Category Name',
    categoryId: 'Category ID',
    categoryNameJapanese: 'Category Name/Japanese',
    categoryNameEnglish: 'Category Name/English',
    categoryNameTraditionalChinese: 'Category Name/Chinese(tradition)',
    categoryNameSimplifiedChinese: 'Category Name/Chinese(simplified)',
    categoryNameKorean: 'Category Name/Korean',
    save: 'Save',
    implementationGroup: 'Active Group',
    implementationTiming: 'Active Timing',
    menuOnOrder: 'Menu',
    recommend: 'Recommendation',
    recommendMenu: 'Recommended Menu',
    startTime: 'Begin Date',
    endTime: 'End Date',
    eventName: 'Event Name',
    conditionBranch: 'Conditional Branch',
    behavior: 'Action',
    shopName: 'Restaurant Name',
    shopId: 'Restaurant ID',
    select: 'Select',
    unselected: 'Not Selected',
    operation: 'Use',
    stop: 'Stop',
    setting: 'Settings',
    cancel: 'cancel',
    add: 'Add',
    display: 'Display',
    hidden: 'Hidden',
    yen: 'yen',
    twGen: 'NTD',
    cnGen: 'CNY',
    dollar: '${price}',
    isSuccess: ' success',
    isFailure: ' failed',
    hasRegistered: ' registered',
    hasNotRegistered: ' registration failed',
    hasUpdated: ' updated',
    hasNotUpdated: ' update failed',
    backToHome: 'Back to Main Menu',
  },
  commonCsvUpload: {
    processWaiting: 'Waiting for proceed',
    processing: 'Processing',
    imported: 'Import Complete',
    error: 'Error',
  },
  loginPage: {
    loginPageName: 'Mobile Order Admin Login',
    login: 'Login',
    orderWithTheSmartphone: 'Mobile Order Login',
  },
  accountManagementPage: {
    userList: 'User List',
    userName: 'User Name',
    userId: 'User ID',
    userRegistration: 'User Login',
    emailAddress: 'Email Address',
    password: 'Password',
    passwordConfirmation: 'Confirm Password',
    name: 'Name',
    authority: 'Authority',
    authorityList: 'Authority List',
    screen: 'Screen',
    all: 'All',
    ShopWholeConfig: 'Universal Setting',
    editUser: 'Edit User',
    deletionConfirmation: 'Delete. Continue?',
    deleteUser: 'Delete User',
  },
  orderPage: {
    lineup: 'Item List',
    itemCsvUpload: 'Item CSV upload',
    calorieCsvUpload: 'Carolie CSV upload',
    itemCsvDownload: 'Item CSV download',
    calorieCsvDownload: 'Carolie CSV download',
    registrationConfirmation: 'Registering. Continue?',
    imageDeletionConfirmationBefore: 'Is sure to delete',
    imageDeletionConfirmationAfter: 'image?',
    priceChange: 'Price Change',
    applicable: 'Applicable',
    notApplicable: 'Not Applicable',
    itemInformationRegistration: 'Register Item Info',
    japanese: 'Japanese',
    english: 'English',
    traditionalChinese: 'Chinese(tradition)',
    simplifiedChinese: 'Chinese(simplified)',
    korean: 'Korean',
    productionLanguage1: 'Item language1',
    productionLanguage2: 'Item language2',
    productionLanguage3: 'Item language3',
    productionLanguage4: 'Item language4',
    productionLanguage5: 'Item language5',
    productionLanguage6: 'Item language6',
    productionLanguage7: 'Item language7',
    productionLanguage8: 'Item language8',
    productionLanguage9: 'Item language9',
    productionLanguage10: 'Item language10',
    itemCode: 'Item CODE',
    itemName: 'Item name',
    displayMenu: 'Display MENU',
    displayWide: 'Wide display',
    unitType: 'Unit',
    provideUnitId: 'Provide unit ID',
    toppingType: 'Garnishment',
    typesOfGarnishments: 'Types of garnishments',
    manufacturingDivisionId: 'Manufacturing division ID',
    tagTextString: 'Tag text string',
    plate: 'Plate',
    piece_hon: 'Bottle',
    piece_ko: 'Piece',
    cup: 'Cup',
    itemInformationUpload: 'Upload Item Info',
    itemInformationCsv: 'CSV Item Info',
    editItemInformation: 'Edit Item Info',
    searchTagInformationUpload: 'Upload Search Tag Info',
    searchTagInformationCsv: 'Search Tag Info CSV',
    deleteSearchTag: 'Delete Search Tag',
    itemImageUploadAttention:
      '※The image will go live as soon as after selecting an image.',
    dragAndDropHere: 'Drag or drop images here.',
    orSelectFile: 'Select File',
    fileOverwriteAttention:
      '※File with same name will be override the old file.',
    uploadImageList: 'Upload Image List',
    successfulUploadItemImage: 'Item image uploaded successfully.',
    pendingUploadItemImage: 'Preparing for upload.',
    processingUploadItemImage: 'Uploading...',
    invalidUploadItemImage: 'This type of file is not supported.',
    failureUploadItemImage: 'Item image upload failed.',
    uploadAlert: 'There are images being processed. Do you want to move?',
    deleteItemImage: 'Delete image',
    searchSettings: 'Search Settings',
    item: 'Items',
    tag: 'tag ID',
    searchTag: 'Search Tag',
    addTag: 'Add Tag',
    addSearchTag: 'Add Search Tag',
    addShop: 'Add Restaurant',
    tagId: 'Tag ID',
    searchTagName: 'Search Tag Name',
    searchTagInformation: 'Search Tag Info',
    addItem: 'Add Item',
    categoryList: 'Category List',
    categoryInformationRegistration: 'Register Category Info',
    inputConfirmation: 'Confirm',
    registration: 'Register',
    editCategoryInformation: 'Edit Category Ingo',
    categoryDeletionConfirmationBefore: 'Delete Category',
    categoryDeletionConfirmationAfter: '?',
    deleteCategoryBefore: 'Delete Category',
    deleteCategoryAfter: '',
    changeCategoryDisplayOrder: 'Change Display Order',
    createNewMenu: 'Add',
    copyPublishedMenuNotice: 'Create new menu by copying the published menu.',
    noOpenMenu: 'No published menu available.',
    createOpenMenu: 'Please create published menu.',
    editDraft: 'Edit Draft',
    editDraftNotice: 'Edit current new menu.',
    editPublishedMenu: 'Edit Published Menu.',
    editPublishedMenuNotice: 'Edit Published Menu.',
    menuDraft: 'Menu Draft',
    menuConfig: 'Menu Settings',
    editingTheMenuInOperation: 'Editing Published Menu.',
    useStartTime: 'Begin Date',
    useEndTime: 'End Date',
    menuStatus: 'Menu Status',
    draft: 'Draft',
    inOperation: 'In Use',
    inOperationMenu: 'Published Menu.',
    preview: 'Preview',
    menuDisplay: 'Menu Display',
    wideDisplay: 'Wide Display',
    editingDraft: 'Editing Draft',
    tableNo: 'Table Number',
    call: 'Help',
    check: 'Checkout',
    priceInformation: 'Price Info',
    priceInformationList: 'Price Info List',
    pricePatternId: 'Price Pattern ID',
    pricePatternIdCsv: 'Price pattern ID',
    pricePatternName: 'Price Pattern Name',
    pricePatternNameCsv: 'Price pattern name',
    priceId: 'Price ID',
    priceName: 'Name',
    updateCategory: 'Update category',
    priceInformationUpload: 'Upload Price Info',
    priceInformationCsv: 'Price Info CSV',
    itemCalorie: 'Calorie Info',
    itemCalorieUpload: 'Upload Calorie Info',
    itemCalorieCsv: 'Calorie Info CSV',
  },
  adPage: {
    recommendOnOrderList: 'Recommended Item List',
    recommendOnOrderRegistration: 'Register Recommended Item',
    orderMenu: 'Order Menu',
    editRecommendOnOrder: 'Edit Recommended Item',
    recommendUpload: 'Upload Recommended Item',
    recommendCsv: 'Recommended Item CSV',
    recommendOnOrderDeletionConfirmation: 'Delete Recommended Item Info?',
    timedRecommendDeletionConfirmation:
      'Delete Limited Time Recommended Item Info?',
    deleteRecommendOnOrder: 'Delete Recommended Item Info',
    deleteTimedRecommend: 'Delete Limited Time Recommended Item Info',
    timedRecommendList: 'Limited Time Recommended Item List',
    timedRecommendRegistration: 'Register Limited Time Recommended Item',
    implementationTimingConditions: 'Implementation Timing Condition',
    elapsedTime: 'Elapsed Time',
    minutesLater: 'Minutes Later',
    timedRecommendImage: 'Limited Time Recommended Item Image',
    imageUploadDescription: 'Upload png or jpg file of up to 1MB.',
    recommendPeriod: 'Recommendation Time Period',
    recommendPeriodStart: 'Recommendation Time Period (Start Date)',
    recommendPeriodEnd: 'Recommendation Time Period (End Date)',
    fromTheFirstOrder: 'First Order',
    fromTheLastOrder: 'Last Order',
    immediatelyAfterAuthentication: 'After Confirmation',
    editTimedRecommend: 'Edit Limited Time Recommended Item',
    itemIsYetNotRegistered: 'Item is not registered',
  },
  eventInformationPage: {
    deleteEventInformation: 'Delete Event Info',
    eventRegistration: 'Register Event',
    editEvent: 'Edit event',
    postingTerm: 'Display Time Period',
    postingTermStart: 'Display Time Period（Start Date）',
    postingTermEnd: 'Display Time Period（End Date）',
    startDate: 'Start Date',
    yearsMonthDate: 'yy/mm/dd',
    endDate: 'End Date',
    decisionTiming: 'Determination Timing',
    whenSeatAuthentication: 'Seated Confirmation',
    whenOrder: 'Order',
    eventConditions: 'Event Condition',
    birthMonth: 'Birth Month',
    visitInBirthMonth: 'Dine in Birth Month',
    operationAtConditionCoincidence: 'Action when the conditions match',
    gachadamaEmission: 'Bikkurapon Discharge',
    bikkuraponLottery: 'Bikkurapon Lottery',
    optionalVideo: 'Random Clip',
    videoName: 'Video Name',
    shopGroupList: 'Restaurant Group List',
    groupId: 'Group ID',
    groupName: 'Group Name',
    userAttribute: 'User attributes',
    emission: 'Discharge',
    lottery: 'lottery',
    video: 'Video',
    eventInformationDeletionConfirmation:
      'Are you sure to delete event information?',
  },
  operationalManagementPage: {
    soOrderLimitCountAttention:
      'All restaurant settings will be changed when editing the limit number.',
    orderLimit: 'SO order number limit',
    orderLimitShop: 'SO order number limit（Restaurant）',
    orderLimitTable: 'SO order number limit（Table）',
    orderLimitPreOrder: 'SO order number limit（Pre-order）',
    itemMinMax: '0~99',
    table: 'Table',
    preOrder: 'Pre-order',
    soOperationAttention:
      'Set to operation on regular basis - only change when in a situation to stop function at all restaurants.',
    soOperation: 'SO operation',
    bikkuraponRateChange: 'Adjust the chance of Bikkurapon',
    priceDisplay: 'Price Display',
    bikkuraponIconDisplay: 'Bikkurapon Icon Display',
    kuraCode: 'くら寿司 Restaurant CODE',
    shopName: 'Restaurant name',
    eparkGourmetId: 'EPARK GOURMET ID',
    eparkTakeoutId: 'EPARK TAKEOUT ID',
    tableCount: 'Restaurant table count',
    lastOrder: 'Last order',
    shopLimitNumber: 'Restaurant Limit',
    soOperationalStatus: 'SO operation status',
    selfCheckOperationalStatus: 'Self checkout operation status',
    shopConfig: 'Restaurant Settings',
    qrForSeat: 'Table QR CODE',
    qrCodeDisplayForSeatAuthorization: 'Display table confirmation QR code',
    wholeSelection: 'Select All',
    wholeDeselection: 'Unselect All',
    printSelectedQr: 'Print selected QR code',
    soWebSupportedVersion: 'SOWeb supported version(NEW)',
    appVersion: 'APP version (OLD)',
    shopNumber: 'Restaurant Number',
    seatNumber: 'Table Number',
    changeQr: 'Change QR code',
    qrCodeIsUnselected: 'QR code not selected',
    qrCodeUnset: 'QR code has not been set',
    ofQrCode: 'QR code',
    qrCodeChange: 'Change QR code',
    qrCodePrinting: 'Print QR code',
    shopInformation: 'Restaurant Info',
    shopInformationRegistration: 'Register Restaurant Info',
    editShopInformation: 'Edit Restaurant Info',
    priceBand: 'Price range',
    numberOfSeats: 'Number of table',
    gourmetShopId: 'EPARK Gourmet ID',
    takeOutShopId: 'EPARK Takeout ID',
    soOrderLimit: 'SO order limit',
    soOrderLimitAllSeats: 'SO order limit（All Restaurants）',
    soOrderLimitTable: 'SO order limit（table）',
    soOrderLimitPreOrder: 'SO order limit（Pre-order）',
    allSeats: 'All Restaurants',
    selfcheckOperation: 'Self checkout operation',
    shopInformationUpload: 'Upload Restaurant Info',
    shop: 'Restaurant',
    group: 'Group',
    addGroup: 'Add group',
    shopGroupInformationUpload: 'Upload Restaurant Group Info',
    shopGroupInformation: 'Restaurant Group Info',
    addShopGroup: 'Add Restaurant Group',
    deleteShopGroup: 'Delete Restaurant Group',
    update: 'Update',
    globalSettings: 'All settings',
    stopping: 'Stopping',
    emissionSetting: 'Discharge setting',
    numberOfTimes: 'times',
    probability: 'Percentage',
    individualSetting: 'Individual settings',
    bikkuraponInstallation: 'Bikkurapon Setting',
    amountOfMoney: 'Amount of money',
    rotation: 'times',
    probabilityPercent: 'Percentage(%)',
    notInstalled: 'Not Set',
    off: 'NO',
    on: 'YES',
  },
}

export default us
